import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'chart.js';
import 'src/assets/css/Kpis.css';

const FloatingBarsChart = (props) => {
  const chartRef = useRef(null);
  const [showLegends, setShowLegends] = useState(false);
  const [height, setHeight] = useState(300);

  useEffect(() => {
    // Custom chart data and options
    const customData = {
      labels: [

        '2022 May',
        '2022 Jun',
        '2022 Jul',
        '2022 Aug',
        '2022 Sep',
        '2022 Oct',
        '2022 Nov',
        '2022 Dec',
      ],
      datasets: [
        {
          label: 'Hershey',
          data: [

            [40, 55],
            [55, 65],
            [25, 40],
            [40, 45],
            [30, 45],
            [44, 55],
            [70, 45],
            [50, 45],
            [65, 75],
            [55, 45],
          ],
          backgroundColor: '#36A2EB',
        },
        {
          label: 'Kisses',
          data: [
            [25, 40],
            [44, 55],
            [70, 45],
            [50, 45],
            [65, 75],
            [45, 25],
            [25, 40],
            [30, 15],
            [24, 55],
            [25, 35],
          ],
          backgroundColor: '#FF6384',
        },
        {
          label: 'Nugget',
          data: [
            [45, 23],
            [25, 2],
            [35, 10],
            [10, 45],
            [45, 53],
            [55, 62],
            [45, 50],
            [30, 65],
            [50, 45],
            [40, 55],
            [50, 75],
            [65, 75],
            [25, 40],
            [70, 45],
            [50, 45],
            [65, 75],
          ],
          backgroundColor: '#4BC0C0',
        },
      ],
    };

    // Define initial chart options
    const initialOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: true, // Initially hide legends
          position: 'bottom',
          align: 'left',
          labels: {
            boxWidth: 10,
            borderWidth: 0,
            textAlign: 'left',
            color:'black',
            font: {
              size: 10,
            },
          },
        },
      },
    };

    // Create the chart
    const ctx = chartRef.current.getContext('2d');
    const myChart = new Chart(ctx, {
      type: 'bar',
      data: customData,
      options: initialOptions, // Use initial options
    });



    // Cleanup function
    return () => {
      myChart.destroy(); // Destroy the chart when the component unmounts
    };
  }, [showLegends]); // Re-run the effect when showLegends changes

  // Function to toggle legends
  function toggleLegend() {
    setShowLegends(!showLegends);
  }

  return (
    <div className='FloatingBar'>
      <div className='row'>
        <div className='col-lg-5'>
          <div className='componentNameC'>{props.prams.prams.component}</div>
        </div>

        <div className='col-lg-5'></div>

        <div className='col-lg-2'>
          <div className="form-check component_legend">
            <span className="bigcheck">
              <label className="bigcheck">
                {/* <input
                  type="checkbox"
                  className="bigcheck"
                  checked={showLegends}
                //   onChange={toggleLegend}
                  name="Legend"
                  value="yes"
                /> */}
                <span className="bigcheck-target"></span>
                {/* &nbsp; Legend */}
              </label>
            </span>
          </div>
        </div>
      </div>

      <div className="p-2 FloatingBar1">
        <div className="row FloatingBar2">
          <div className='col-lg-12 FloatingBar3'>
            <canvas
              ref={chartRef}
              height={height}
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingBarsChart;
